export const parseAddressFromObject = (obj = {}) => {
    if (!obj?.address) {
        return { venueName: '', streetAddress: '', streetFloor: '', city: '', state: '', zipCode: '' };
    }

    const addressString = obj.address;
    const vname = obj.name;

    const components = addressString.split(',') || [];
    let streetAddress = '';
    let streetFloor = '';
    let city = '';
    let state = '';
    let zipCode = '';

    if (components.length > 0) {
        const [firstPart, secondPart, ...rest] = components;

        // Check if first part contains venue name
        if (firstPart.includes(vname)) {
            streetAddress = firstPart.replace(vname, '').trim();
            streetFloor = secondPart?.trim() || '';
        } else {
            streetAddress = firstPart?.trim() || '';
            streetFloor = secondPart?.trim() || '';
        }

        // Get city, state, zip
        const locationParts = components.slice(-2)[0]?.trim().split(' ') || [];
        city = components.slice(-3)[0]?.trim() || '';
        state = locationParts[0] || '';
        zipCode = locationParts[1] || '';
    }

    return { venueName: vname, streetAddress, streetFloor, city, state, zipCode };
};

export const formatAddressObject = (fields) => {
    return [
        fields.venueName,
        fields.streetAddress,
        fields.streetFloor,
        fields.city,
        fields.state,
        fields.zipCode
    ].filter(Boolean).join(', ');
};

export const parseStoredAddress = (address = '', venueName = '') => {
    if (!address) {
        return { streetAddress: '', streetFloor: '', city: '', state: '', zipCode: '' };
    }

    //if address is already an  object 
    if (typeof address === 'object') {
        return address;
    }

    const components = address?.split(',') || [];
    let streetAddress = '';
    let streetFloor = '';
    let city = '';
    let state = '';
    let zipCode = '';

    if (components.length > 0) {
        const [firstPart, secondPart] = components;

        if (firstPart.includes(venueName)) {
            streetAddress = firstPart.replace(venueName, '').trim();
            streetFloor = secondPart?.trim() || '';
        } else {
            streetAddress = firstPart?.trim() || '';
            streetFloor = secondPart?.trim() || '';
        }

        const locationParts = components.slice(-2)[0]?.trim().split(' ') || [];
        city = components.slice(-3)[0]?.trim() || '';
        state = locationParts[0] || '';
        zipCode = locationParts[1] || '';
    }

    return { streetAddress, streetFloor, city, state, zipCode };
};

export const parseGoogleAddress = (addressComponents) => {
    const components = addressComponents.reduce((acc, comp) => {
        comp.types.forEach(type => acc[type] = comp.long_name);
        return acc;
    }, {});

    const streetNumber = components.street_number || '';
    const route = components.route || '';
    const city = components.locality ||
        components.sublocality_level_1 ||
        components.administrative_area_level_2 ||
        '';
    const state = components.administrative_area_level_1 || '';
    const zipCode = components.postal_code || '';

    return {
        streetAddress: [streetNumber, route].filter(Boolean).join(' ').trim(),
        streetFloor: '',
        city,
        state,
        zipCode
    };
}; 